import React from 'react';
import './HierarchySkeleton.css';

/**
 * HierarchySkeleton - Animated skeleton loader for hierarchy tree
 *
 * Displays during hierarchy fetch from /chat/hierarchy endpoint.
 * Mimics tree structure: domains > exams > topics.
 * Respects prefers-reduced-motion for accessibility.
 */
export const HierarchySkeleton = () => {
  return (
    <div className="hierarchy-skeleton" aria-label="Loading hierarchy">
      {/* Domain 1 */}
      <div className="skeleton-domain">
        <div className="skeleton-line skeleton-domain-line" />

        {/* Exams under Domain 1 */}
        <div className="skeleton-exam">
          <div className="skeleton-line skeleton-exam-line" />

          {/* Topics under Exam 1 */}
          <div className="skeleton-topic">
            <div className="skeleton-line skeleton-topic-line" />
          </div>
          <div className="skeleton-topic">
            <div className="skeleton-line skeleton-topic-line" />
          </div>
          <div className="skeleton-topic">
            <div className="skeleton-line skeleton-topic-line" />
          </div>
        </div>

        {/* Exam 2 under Domain 1 */}
        <div className="skeleton-exam">
          <div className="skeleton-line skeleton-exam-line" />

          {/* Topics under Exam 2 */}
          <div className="skeleton-topic">
            <div className="skeleton-line skeleton-topic-line" />
          </div>
          <div className="skeleton-topic">
            <div className="skeleton-line skeleton-topic-line" />
          </div>
          <div className="skeleton-topic">
            <div className="skeleton-line skeleton-topic-line" />
          </div>
        </div>
      </div>

      {/* Domain 2 */}
      <div className="skeleton-domain">
        <div className="skeleton-line skeleton-domain-line" />

        {/* Exams under Domain 2 */}
        <div className="skeleton-exam">
          <div className="skeleton-line skeleton-exam-line" />

          {/* Topics under Exam */}
          <div className="skeleton-topic">
            <div className="skeleton-line skeleton-topic-line" />
          </div>
          <div className="skeleton-topic">
            <div className="skeleton-line skeleton-topic-line" />
          </div>
          <div className="skeleton-topic">
            <div className="skeleton-line skeleton-topic-line" />
          </div>
        </div>

        {/* Exam 2 under Domain 2 */}
        <div className="skeleton-exam">
          <div className="skeleton-line skeleton-exam-line" />

          {/* Topics under Exam 2 */}
          <div className="skeleton-topic">
            <div className="skeleton-line skeleton-topic-line" />
          </div>
          <div className="skeleton-topic">
            <div className="skeleton-line skeleton-topic-line" />
          </div>
          <div className="skeleton-topic">
            <div className="skeleton-line skeleton-topic-line" />
          </div>
        </div>
      </div>
    </div>
  );
};
